export default __webpack_public_path__ + "static/media/period.6539d082.svg";